import type { AnalyticsClient, AnalyticsEvent } from './analytics';

export const ANALYTICS_ENDPOINT = '/api/analytics';

type AnalyticsRuntime = Readonly<{
  hostname: string;
  fetcher: typeof fetch;
}>;

export function shouldSendAnalytics(hostname: string): boolean {
  return hostname !== 'localhost' && hostname !== '127.0.0.1' && hostname !== '::1';
}

export function serializeAnalyticsEvent(event: AnalyticsEvent): string {
  return JSON.stringify(event);
}

export function createCloudflareAnalyticsClient(runtime?: AnalyticsRuntime): AnalyticsClient {
  const resolvedRuntime: AnalyticsRuntime = runtime ?? {
    hostname: window.location.hostname,
    fetcher: window.fetch.bind(window),
  };

  return {
    track(event) {
      if (!shouldSendAnalytics(resolvedRuntime.hostname)) return;

      // Events are emitted during in-page SPA interactions. Avoid fetch keepalive here:
      // Chromium can leave POST keepalive requests pending or abort them before a response.
      void resolvedRuntime.fetcher(ANALYTICS_ENDPOINT, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: serializeAnalyticsEvent(event),
        cache: 'no-store',
        credentials: 'omit',
        referrerPolicy: 'no-referrer',
      }).catch(() => undefined);
    },
  };
}
